// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Remitos_container__TkSxS {
  animation: Remitos_init__T\\+gVq 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 1rem;
}

.Remitos_container__TkSxS .Remitos_header__myMoN {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_titleContainer__yeTww {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_titleContainer__yeTww h4 {
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_titleContainer__yeTww .Remitos_add_btn__pOtgL {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 6.5rem;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  text-transform: capitalize;
  margin-left: 10px;
}

.Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_filters__Hfhc6 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_filters__Hfhc6 .Remitos_filterButton__mKiDy {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-bottom: 10px;
  border-radius: 5px;
  margin-left: 5px;
}

.Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_filters__Hfhc6 .Remitos_filterButton__mKiDy p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

/*---Información---*/
.Remitos_container__TkSxS .Remitos_dataContainer__q3WUm {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 50px;
}

.Remitos_container__TkSxS .Remitos_noResults__6U33F {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Remitos_container__TkSxS .Remitos_noResults__6U33F p {
  font-size: 1.5rem;
  font-weight: 300;
}

.Remitos_container__TkSxS .Remitos_dataContainer__q3WUm .Remitos_tableContainer__1nrOW {
  margin-top: 10px;
  max-height: 80vh;
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Remitos_container__TkSxS .Remitos_dataContainer__q3WUm .Remitos_tableContainer__1nrOW .Remitos_iconbtn__oFHBY {
  transition: 0.3s;
  font-size: 1.6rem;
}

.Remitos_container__TkSxS .Remitos_dataContainer__q3WUm .Remitos_tableContainer__1nrOW .Remitos_iconbtn__oFHBY:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.Remitos_container__TkSxS .Remitos_pagination__E5O5i {
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 50px;
}

.Remitos_container__TkSxS .Remitos_pagination__E5O5i .Remitos_customPage__yP5u8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@keyframes Remitos_init__T\\+gVq {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/*XS*/
@media screen and (max-width: 500px) {
  .Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_titleContainer__yeTww .Remitos_add_btn__pOtgL {
    width: 80px;
    height: 40px;
  }
  .Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_titleContainer__yeTww h4 {
    font-size: 1.5rem;
  }
}

/*MD*/
@media screen and (max-width: 900px) {
  .Remitos_container__TkSxS .Remitos_header__myMoN .Remitos_filters__Hfhc6 .Remitos_filterButton__mKiDy {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Remitos.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,KAAK;AACL;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,KAAK;AACL;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 1rem;\n}\n\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 6.5rem;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  text-transform: capitalize;\n  margin-left: 10px;\n}\n\n.container .header .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  margin-left: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n/*---Información---*/\n.container .dataContainer {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-bottom: 50px;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .noResults p {\n  font-size: 1.5rem;\n  font-weight: 300;\n}\n\n.container .dataContainer .tableContainer {\n  margin-top: 10px;\n  max-height: 80vh;\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .dataContainer .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 1.6rem;\n}\n\n.container .dataContainer .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .pagination {\n  justify-content: space-evenly;\n  align-items: center;\n  margin-bottom: 50px;\n}\n\n.container .pagination .customPage {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/*XS*/\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer .add_btn {\n    width: 80px;\n    height: 40px;\n  }\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n\n/*MD*/\n@media screen and (max-width: 900px) {\n  .container .header .filters .filterButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Remitos_container__TkSxS`,
	"init": `Remitos_init__T+gVq`,
	"header": `Remitos_header__myMoN`,
	"titleContainer": `Remitos_titleContainer__yeTww`,
	"add_btn": `Remitos_add_btn__pOtgL`,
	"filters": `Remitos_filters__Hfhc6`,
	"filterButton": `Remitos_filterButton__mKiDy`,
	"dataContainer": `Remitos_dataContainer__q3WUm`,
	"noResults": `Remitos_noResults__6U33F`,
	"tableContainer": `Remitos_tableContainer__1nrOW`,
	"iconbtn": `Remitos_iconbtn__oFHBY`,
	"pagination": `Remitos_pagination__E5O5i`,
	"customPage": `Remitos_customPage__yP5u8`
};
export default ___CSS_LOADER_EXPORT___;
